import _typeof from "@babel/runtime/helpers/typeof";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["driverGroupConfig", "driverGroup"];
import "core-js/modules/es6.array.filter.js";
import { getImageAltText, getImageSrc, getName } from '@nerdwallet/marketplace/selectors/common';
export { useLocalStorage } from './useLocalStorage';
export var buildTrkSectionCategory = function buildTrkSectionCategory() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.filter(Boolean).join('__');
};
export var getImageData = function getImageData(marketplaceEntity) {
  var srcSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return {
    src: getImageSrc(marketplaceEntity, srcSize),
    alt: getImageAltText(marketplaceEntity) || getName(marketplaceEntity)
  };
}; // This is the string constant used to represent showing the default drivers
// for a given product.

export var DEFAULT_DRIVER_GROUP = 'DEFAULT_DRIVER_GROUP'; // Gets the drivers to use based off a config object, an optional driver group name,
// and any other props passed to the config functions.  It tries to fallback to
// any declared default configuration, then if it still can't find it, to no drivers.

export var getDrivers = function getDrivers(_ref) {
  var driverGroupConfig = _ref.driverGroupConfig,
      driverGroup = _ref.driverGroup,
      props = _objectWithoutProperties(_ref, _excluded);

  if (_typeof(driverGroupConfig) === 'object') {
    var specificGroupGenerator = driverGroupConfig[driverGroup];

    if (typeof specificGroupGenerator === 'function') {
      return specificGroupGenerator(props);
    }

    var defaultGroupGenerator = driverGroupConfig[DEFAULT_DRIVER_GROUP];

    if (typeof defaultGroupGenerator === 'function') {
      return defaultGroupGenerator(props);
    }
  }

  return {};
};